import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";

const transition = "background-color 0.3s, color 0.3s, box-shadow 0.3s, border 0.3s";

const getTabStyles = (isSelected, isDarkMode) => ({
  padding: "10px 0 !important",
  width: "120px",
  minWidth: "120px",
  flex: "0 0 120px",
  margin: "0 2px",
  backgroundColor: isDarkMode
    ? isSelected
      ? "#181e27ff"
      : "#010409"
    : isSelected
    ? "#FFFFFF"
    : "#F7FAFC",
  color: isDarkMode
    ? isSelected
      ? "#D6DBE4"
      : "#76788A"
    : isSelected
    ? "#2D3748"
    : "#808289",
  boxShadow: isSelected
    ? `0px 2px 5.5px rgba(0, 0, 0, ${isDarkMode ? "0.44" : "0.31"})`
    : "none",
  border: isSelected
    ? `1px solid ${isDarkMode ? "#010409" : "#F7FAFC"}`
    : "1px solid transparent",
  "&:hover": isSelected
    ? {
        backgroundColor: isDarkMode ? "#181e27ff" : "#FFFFFF",
        color: isDarkMode ? "#D6DBE4" : "#2D3748",
        boxShadow: `0px 2px 5.5px rgba(0, 0, 0, ${isDarkMode ? "0.44" : "0.31"})`,
        border: `1px solid ${isDarkMode ? "#010409" : "#F7FAFC"}`,
        transition,
      }
    : {
        backgroundColor: isDarkMode ? "#010409" : "transparent !important",
        color: isDarkMode ? "#FFFFFF" : "#181e27ff",
        transition,
      },
  "&:focus, &:active": {
    backgroundColor: isDarkMode
      ? isSelected
        ? "#181e27ff !important"
        : "#010409 !important"
      : isSelected
      ? "#FFFFFF !important"
      : "#F7FAFC !important",
    color: isDarkMode
      ? isSelected
        ? "#D6DBE4 !important"
        : "#76788A !important"
      : isSelected
      ? "#2D3748 !important"
      : "#808289 !important",
    boxShadow: isSelected
      ? `0px 2px 5.5px rgba(0, 0, 0, ${isDarkMode ? "0.44" : "0.31"}) !important`
      : "none !important",
    border: isSelected
      ? `1px solid ${isDarkMode ? "#05111F" : "#F7FAFC"} !important`
      : "1px solid transparent !important",
    outline: "none !important",
    transition,
  },
  outline: "none",
  transition,
});

const SlugTabs = ({ tabs, value, onChange, align = "center" }) => {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";

  return (
    <SoftBox sx={{ padding: "8px", overflowX: "auto" }}>
      <SoftBox
        sx={{
          alignItems: "center",
          backgroundColor: isDarkMode ? "#010409" : "#F7FAFC",
          borderRadius: "8px",
          display: "flex",
          justifyContent: "center",
          margin: align === "left" ? 0 : "0 auto",
          width: "max-content",
          maxWidth: "none",
        }}
      >
        {tabs.map((tab) => {
          const isSelected = value === tab;

          return (
            <SoftButton
              key={tab}
              sx={getTabStyles(isSelected, isDarkMode)}
              size="medium"
              onClick={() => onChange(tab)}
              className={isSelected ? "tab selected" : ""}
              aria-pressed={isSelected}
            >
              {tab}
            </SoftButton>
          );
        })}
      </SoftBox>
    </SoftBox>
  );
};

SlugTabs.propTypes = {
  tabs: PropTypes.arrayOf(PropTypes.string).isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  align: PropTypes.oneOf(["center", "left"])
};

export default SlugTabs;
